// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3osdo","messages":"Chat_messages__29BVa","dateDivider":"Chat_dateDivider__257Hm"};